import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { setPlaybackRate } from '../../../../store/bite/bite.actions';
import { playbackRateSelector } from '../../../../store/bite/bite.selectors';
import PlaybackRateOverlay from '../../../../screens/viewBite/Intro/components/PlaybackRateOverlay';
import { BooleanValueInstance } from '../../../../hooks/useBooleanValue';

type Props = {
  overlayVisibilityState: BooleanValueInstance;
};
const PlaybackRate = ({ overlayVisibilityState }: Props) => {
  const dispatch = useDispatch();

  const playbackRate = useSelector(playbackRateSelector);

  const handleSelect = useCallback(
    (rate: number) => {
      dispatch(setPlaybackRate(rate));
    },
    [dispatch],
  );

  return (
    <>
      <S.Btn onClick={overlayVisibilityState.setTrue}>{playbackRate}x</S.Btn>
      <PlaybackRateOverlay
        isVisible={overlayVisibilityState.state}
        rate={playbackRate}
        onSelect={handleSelect}
        onClose={overlayVisibilityState.setFalse}
      />
    </>
  );
};
export default memo(PlaybackRate);

export const S = {
  Btn: styled.div`
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 100%;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    transition: opacity 150ms ease-in-out;
  `,
  Label: styled.div`
    margin-right: 4px;
    font-size: 17px;
    font-weight: 400;
    font-family: ${({ theme }) => theme.fontFamilies.Arimo};
  `,
  Loader: styled.div`
    width: 32px;
  `,
};
